import { AccountPanel } from "../components/AccountPanel";
import { ConvergenceMatrixPanel } from "../components/ConvergenceMatrixPanel";
import { LocalSignalsPanel } from "../components/LocalSignalsPanel";
import { RiskPanel } from "../components/RiskPanel";
import { SystemHealthPanel } from "../components/SystemHealthPanel";
import { useOverviewPoll } from "../hooks/useOverviewPoll";

export function OverviewPage() {
  const {
    account,
    accountError,
    risk,
    riskError,
    matrix,
    forceRefresh,
    lastTick,
  } = useOverviewPoll();

  return (
    <div className="flex flex-col gap-4">
      <header className="flex items-baseline justify-between">
        <h1 className="text-xl font-bold tracking-tight">Overview</h1>
        <span className="text-xs text-fg-muted">
          {lastTick ? `updated ${lastTick.toLocaleTimeString()}` : "loading…"}
        </span>
      </header>

      <SystemHealthPanel />

      <div className="grid gap-4 lg:grid-cols-3">
        <AccountPanel account={account} error={accountError} />
        <RiskPanel
          risk={risk}
          riskError={riskError}
          account={account}
          onChange={forceRefresh}
        />
        <ConvergenceMatrixPanel matrix={matrix} />
      </div>

      <LocalSignalsPanel />
    </div>
  );
}
